var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChatActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_133_1186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.875 3.75H4.375C4.03 3.75 3.75 4.03 3.75 4.375C3.75 4.72 4.03 5 4.375 5H11.875C12.22 5 12.5 4.72 12.5 4.375C12.5 4.03 12.22 3.75 11.875 3.75Z",
    fill: "#4E80EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.375 6.25H4.375C4.03 6.25 3.75 6.53 3.75 6.875C3.75 7.22 4.03 7.5 4.375 7.5H9.375C9.72 7.5 10 7.22 10 6.875C10 6.53 9.72 6.25 9.375 6.25Z",
    fill: "#4E80EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.75 0H2.5C1.12125 0 0 1.12125 0 2.5V15C0 15.2425 0.14 15.4637 0.36 15.5662C0.44375 15.605 0.535 15.625 0.625 15.625C0.76875 15.625 0.91125 15.575 1.025 15.48L4.60125 12.5H13.75C15.1287 12.5 16.25 11.3787 16.25 10V2.5C16.25 1.12125 15.1287 0 13.75 0ZM15 10C15 10.6888 14.44 11.25 13.75 11.25H4.375C4.22875 11.25 4.0875 11.3013 3.975 11.395L1.25 13.6662V2.5C1.25 1.81125 1.81 1.25 2.5 1.25H13.75C14.44 1.25 15 1.81125 15 2.5V10Z",
    fill: "#4E80EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 5C17.155 5 16.875 5.28 16.875 5.625C16.875 5.97 17.155 6.25 17.5 6.25C18.19 6.25 18.75 6.81125 18.75 7.5V18.0737L16.64 16.3863C16.53 16.2987 16.3912 16.25 16.25 16.25H7.5C6.81 16.25 6.25 15.6888 6.25 15V14.375C6.25 14.03 5.97 13.75 5.625 13.75C5.28 13.75 5 14.03 5 14.375V15C5 16.3787 6.12125 17.5 7.5 17.5H16.03L18.9838 19.8637C19.0975 19.9537 19.2362 20 19.375 20C19.4663 20 19.5588 19.98 19.6462 19.9388C19.8625 19.8338 20 19.615 20 19.375V7.5C20 6.12125 18.8787 5 17.5 5Z",
    fill: "#4E80EE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_133_1186"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatActive);
export default __webpack_public_path__ + "static/media/chat-active.eb22ce1b887dfa49fb834207e88f8e1c.svg";
export { ForwardRef as ReactComponent };